export default "__VITE_ASSET__CiQkCDci__"